export const solutions = [
  {
    index: '01',
    title: 'Estructuración de negocios',
    description:
      'Diseño y análisis jurídico, societario, contable y financiero de nuevas estructuras y operaciones.',
  },
  {
    index: '02',
    title: 'Crecimiento & expansión',
    description: 'Acompañamiento estratégico durante procesos de crecimiento empresarial.',
  },
  {
    index: '03',
    title: 'Reorganizaciones societarias',
    description: 'Evaluación y estructuración de alternativas para organizaciones en transformación.',
  },
  {
    index: '04',
    title: 'Inversiones & nuevos proyectos',
    description:
      'Análisis integral previo a decisiones de inversión y desarrollo de nuevas unidades de negocio.',
  },
  {
    index: '05',
    title: 'Prevención & gestión de riesgos',
    description:
      'Identificación anticipada de contingencias legales, fiscales, financieras y societarias.',
  },
  {
    index: '06',
    title: 'Transacciones complejas',
    description:
      'Coordinación multidisciplinaria en operaciones donde intervienen diferentes áreas técnicas.',
  },
];

export const areas = [
  {
    number: '01',
    name: 'Legal',
    description:
      'Asesoría orientada a la prevención, no al litigio. Trabajamos para que el cliente no deba atravesar una instancia judicial: due diligence en procesos de M&A, diseño de mecanismos de corporate governance, estructuración societaria y contratos pensados para anticipar el conflicto antes de que ocurra. Cuando la controversia es inevitable, priorizamos vías extrajudiciales —negociación, mediación o arbitraje— reservando la instancia judicial como último recurso.',
    fields: ['M&A', 'corporate governance', 'societario', 'contractual', 'due diligence'],
    concepts: 'prevención / previsibilidad / estrategia',
    image: '/images/area-legal.jpg',
  },
  {
    number: '02',
    name: 'Contable',
    description:
      'Liquidación de impuestos y presentaciones ante ARCA y demás organismos de contralor —nacionales, provinciales y municipales—, con planificación fiscal orientada a optimizar la carga tributaria dentro del marco legal vigente. Incluye análisis de cash flow y elaboración de estados contables que funcionan como base de las decisiones financieras y legales del negocio, no como mero cumplimiento formal.',
    fields: ['fiscalidad', 'ARCA', 'planificación fiscal', 'cash flow', 'estados contables'],
    concepts: 'información / control / decisión',
    image: '/images/area-contable.jpg',
  },
  {
    number: '03',
    name: 'Notarial',
    description:
      'Instrumentación pública de los actos que dotan de plena seguridad jurídica a la operación: constitución de sociedades, escrituras, actas societarias y certificaciones. Es la instancia que convierte cada decisión legal y financiera en un acto con validez formal y oponibilidad frente a terceros; el paso que transforma una decisión de negocio en un derecho plenamente exigible.',
    fields: ['sociedades', 'escrituras', 'actas societarias', 'certificaciones'],
    concepts: 'autenticidad / seguridad / validez',
    image: '/images/area-notarial.jpg',
  },
  {
    number: '04',
    name: 'Financiera',
    description:
      'Estructuración de financiamiento, análisis de inversión y planificación patrimonial a lo largo de todo el ciclo de vida del negocio: desde el diseño de la estructura de capital inicial hasta la evaluación de nuevas rondas de inversión, procesos de expansión o reestructuración financiera.',
    fields: ['financiamiento', 'inversión', 'estructura de capital', 'planificación patrimonial'],
    concepts: 'análisis / proyección / sostenibilidad',
    image: '/images/area-financiera.jpg',
  },
];